import styled from 'styled-components'

export const Award = styled.div`
  display: inline-flex;
  border-radius: var(--radius-brand);
  padding: 2px var(--space-200);
  background: var(--bg-success);
  color: var(--text-primary-invert);
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  font-family: var(--font-family-body);

  font-style: normal;
  font-weight: var(--font-weight-medium);

  letter-spacing: var(--font-letter-spacing-loose);
`
